<div class="row">
    <div class="col-8">
        <rask-input label="Namn"
            class="w-100"
            [maxlength]="arbetsorderNamnMaxLength"
            [(ngModel)]="arbetsorder.namn"
            (change)="arbetsorderNamnUpdated()"
            [disabled]="!isDetailEditable()"
            [rule]="validationContext.current.arbetsordernamn"></rask-input>
    </div>
    <div class="col-4">
        <rask-textmultiline label="LKD">
            <div>{{arbetsorder.lkd}}</div>
        </rask-textmultiline>
    </div>
</div>
<div class="row mt-3">
    <div class="col-4">
        @if (isSchemalagd()) {
        <rask-textmultiline label="Länk till Prolog">
            <a href="{{prologLink()}}" target="_blank">
                {{arbetsorder.beteckning}}</a>
        </rask-textmultiline>
        }
    </div>
    <div class="col-4">
        @if (relateradArbetsorderAtgarder) {
        <rask-textmultiline
            label="{{isRelateradArbetsorderGrot() ? 'Relaterad AO Grot' : 'Relaterad AO Rundvirke'}}">
            @for (relateradAtgard of relateradArbetsorderAtgarder; track relateradAtgard) {
            <div>
                <a [routerLink]="['/planera', relateradAtgard.arbetsorderId]">
                    {{relateradAtgard.arbetsorderBeteckning}}
                </a>
            </div>
            }
        </rask-textmultiline>
        }
    </div>
    <div class="col-4">
        @if (arbetsorder.isAvverkning) {
        <div>
            <rask-textmultiline label="Grotanpassning">
                {{atgarderWithKoppladeGrotAtgarder().length}}/{{arbetsorder.atgarder.length}}
            </rask-textmultiline>
        </div>
        }
    </div>
</div>
<div class="row">
    <div class="col-4">
        <rask-textmultiline label="Produktionsstatus"
            [value]="arbetsorder.produktionsstatus | produktionsstatus"></rask-textmultiline>
    </div>
    <div class="col-4">
        <rask-textmultiline label="Planeringsstatus">
            <rask-planeringsstatus-indicator
                [planeringsstatus]="arbetsorder.planeringsstatus">
            </rask-planeringsstatus-indicator>
            <span> {{ arbetsorder.planeringsstatus }}</span>
        </rask-textmultiline>
    </div>
    <div class="col-4">
        <rask-textmultiline label="Arbetsorder avslutad">
            @if (arbetsorder?.tidpunkter?.produktionGodkandDatum) {
            <span>{{arbetsorder.tidpunkter.produktionGodkandDatum
                | date:'shortDate' }}</span>
            } @else {
            <span>-</span>
            }
        </rask-textmultiline>
    </div>
</div>
<div class="row">
    @if (uppdragsListaAktiv) {
    <div class="col-4">
        <rask-selector
            label="Uppdrag"
            [values]="uppdragsListaAktiv"
            [disabled]="!isDetailEditable()"
            [reverseLookup]="true"
            [ngModel]="arbetsorder.uppdragId"
            [formatter]="uppdragFormatter"
            [viewSelectedFormatter]="uppdragSelectedFormatter"
            placeholder="Välj uppdrag"
            [viewFormatter]="uppdragViewFormatter"
            (ngModelChange)="arbetsorderUppdragUpdated($event)"
            [addModelValueWhenMissing]="getUppdragInitialValue"
            infoText="För Viol3 används uppdrag endast internt på Sveaskog. Om du har behov av andra koder vid extraordinär händelse, kontakta förvaltningen.">
        </rask-selector>
    </div>
    }
    <div class="col-4">
        <rask-input
            label="Virket märkt"
            [(ngModel)]="arbetsorder.virketMarkt"
            (change)="arbetsorderVirketMarktUpdated()"
            [disabled]="!isDetailEditableAfterSend()"
            [maxlength]="10"
            [rule]="validationContext.current.arbetsorderVirketMarkt"></rask-input>
    </div>
    <div class="col-4">
        @if (arbetsorder.viol3) {
        <rask-textmultiline label="VIOL3-Status">
            <rask-viol3status-indicator
                [arbetsorderid]="arbetsorder.id">
            </rask-viol3status-indicator>
        </rask-textmultiline>
        }
        @else {
        <rask-textmultiline label="Virkesorderstatus">
            <rask-virkesorderstatus-indicator
                [virkesorderstatus]="arbetsorder.virkesorderStatus"
                [isRaskVo]="isRaskVo()">
            </rask-virkesorderstatus-indicator>
        </rask-textmultiline>
        }
    </div>
</div>
<div class="row mt-3">
    <div class="col-5">
        <rask-selector
            label="Ansvarig för avverkning"
            [disabled]="!isDetailEditable()"
            aid="ansvarigAvverkningsledare"
            [debounceTime]="300"
            [minCharacters]="3"
            [reverseLookup]="false"
            [ngModel]="avverkningsAnsvarig"
            (ngModelChange)="selectedAvverkningsledare($event)"
            [formatter]="ansvarigFormatter"
            [viewSelectedFormatter]="ansvarigSelectedFormatter"
            placeholder="Ange minst tre tecken"
            [search]="searchForAnsvarigAvverningsledareTypeAhead"
            [viewFormatter]="ansvarigViewFormatter">
        </rask-selector>
    </div>
    <div class="col-2">

    </div>
    @if (canAvslutaVirkesorder()) {
    <div class="col-5">
        <rask-avsluta-virkesorder-button
            [arbetsorder]="arbetsorder">
        </rask-avsluta-virkesorder-button>
    </div>
    }
    @if (canAvslutaViol3Avtalsobjekt()) {
    <div class="col-5">
        <rask-arbetsorder-viol3-makulera-button
            [arbetsorder]="arbetsorder">
        </rask-arbetsorder-viol3-makulera-button>
    </div>
    }
    @if (canMakuleraArbetsorder()) {
    <div class="col-5">
        <rask-makulera-arbetsorder-button
            [arbetsorder]="arbetsorder">
        </rask-makulera-arbetsorder-button>
    </div>
    }
</div>
<div class="row">
    <rask-checkbox class="col-3" text="FSC" label="Certifikat" [(ngModel)]="arbetsorder.fscCertifikat"
        (ngModelChange)="setCertifikat($event)" [disabled]="arbetsorder.isVirkeskop"></rask-checkbox>
    <rask-checkbox class="col-3" text="PEFC" [(ngModel)]="arbetsorder.pefcCertifikat"
        (ngModelChange)="setCertifikat($event)" [disabled]="arbetsorder.isVirkeskop"></rask-checkbox>


    @if (arbetsorder.isExport && tullkontorList) {
    <div class="row">
        <div class="col-8">
            <rask-selector label="Tullkontor"
                [values]="tullkontorList"
                [reverseLookup]="false"
                [disabled]="!isDetailEditable()"
                [ngModel]="arbetsorder.tullkontor"
                (ngModelChange)="selectTullkontor($event)"
                [formatter]="tullkontorFormatter"
                [viewSelectedFormatter]="tullkontorSelectedFormatter"
                placeholder="Välj tullkontor"
                [viewFormatter]="tullkontorViewFormatter">
            </rask-selector>
        </div>
        <div class="col-4">
        </div>
    </div>
    }
    @if (arbetsorder.isVirkeskop && arbetsorder.virkeskopskontraktDetail) {
    <div class="row">
        <div class="col-4">
            <rask-textmultiline label="Ingår i kontrakt">
                @if (canOpenVirkeskopskontrakt()) {
                <div>
                    <a
                        [routerLink]="['/virkeskop/avtal', arbetsorder.virkeskopskontraktDetail.virkesavtalId]"
                        [queryParams]="{kontraktId : arbetsorder.virkeskopskontraktDetail.virkeskontraktId}">
                        {{arbetsorder.virkeskopskontraktDetail.kontraktnummer}}
                        {{arbetsorder.virkeskopskontraktDetail.benamning}}</a>
                </div>
                }
                @if (!canOpenVirkeskopskontrakt()) {
                <div>
                    <span>{{arbetsorder.virkeskopskontraktDetail.kontraktnummer}}
                        {{arbetsorder.virkeskopskontraktDetail.benamning}}</span>
                </div>
                }
            </rask-textmultiline>
        </div>
        <div class="col-4">
            <rask-textmultiline label="Virkesköpare"
                [value]="arbetsorder.virkeskopskontraktDetail.ansvarigVirkeskopareNamn"></rask-textmultiline>
        </div>
        <div class="col-4">
            <rask-textmultiline label="Leverantör" [value]="arbetsorder.virkeskopskontraktDetail.leverantor">
            </rask-textmultiline>
        </div>
    </div>
    }
    @if (arbetsorder.villkorligaDatum.length > 0) {
    <div class="row mt-2">
        <div class="col-12">
            <rask-div-list [data]="arbetsorder.villkorligaDatum" [rowDrag]="false">
                <rask-list-column header="Villkor" field="villkor">
                    <ng-template let-row="row">
                        @if (!isBetweenDateRange(row)) {
                        <span><i class="fal fa-exclamation-square warning"></i></span>
                        }
                        @if (isBetweenDateRange(row)) {
                        <span><i class="fas fa-check-circle success"></i></span>
                        }
                        {{ row.villkor}}
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Datumintervall" field="dates">
                    <ng-template let-row="row">
                        {{formatService.dateFormatRange(row.startdatum, row.slutdatum)}}
                    </ng-template>
                </rask-list-column>
            </rask-div-list>
        </div>
    </div>
    }